import type {ReactElement} from 'react';
import React from 'react';
import {APIProvider} from '@vis.gl/react-google-maps';
import type {GoogleMapAutocompleteProps} from '@Components/google-map/components/google-map-autocomplete/google-map-autocomplete.types';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import {GoogleMapAutocompleteContent} from '@Components/google-map/components/google-map-autocomplete-content';

export function GoogleMapAutocomplete({googleMapAPIKey, onLocationChange, inputFieldSize = InputFieldSize.XSMALL}: GoogleMapAutocompleteProps): ReactElement<any> {
  return (
    <APIProvider apiKey={googleMapAPIKey}>
      <GoogleMapAutocompleteContent googleMapAPIKey={googleMapAPIKey} onLocationChange={onLocationChange} inputFieldSize={inputFieldSize} />
    </APIProvider>
  );
}
